import { render } from "./Register.vue?vue&type=template&id=1ae03cc2"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=1ae03cc2&lang=css"
script.render = render

export default script